const prefix = 'DimCommodity';

export enum DimCommodityField {
  ID = `${prefix}.id`,
  DESCRIPTION = `${prefix}.description`,
}
